import api from '../api/api';

type SyncModulesParams = {
  add?: string;
  delete?: string;
  emails?: string;
};

export class CognitoService {
  static async sincronizarModulos({
    add = '',
    delete: deleteParam = '',
    emails = '',
  }: SyncModulesParams = {}): Promise<string> {
    const response = await api.get('/cognito/sincronizar-modulos', {
      params: {
        add,
        delete: deleteParam,
        emails,
      },
    });

    return response.data;
  }
}
